__turbopack_context__.v({
  "counterOfferModalContainer": "styles-module__6j4Xua__counterOfferModalContainer",
});
